import { ResourceRef } from 'api/types';
import { fileCacheStore } from 'state/store';

export const selectCachedFile = (resource: ResourceRef) => {
    if (!resource.id) return '';
    return fileCacheStore.get(resource.id);
};
